import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  height: 22px;

  white-space: nowrap;

  background-color: ${p => p.background};
  color: ${p => p.color};

  border-radius: 60px;

  font-size: 10px;
  line-height: 22px;

  cursor: pointer;
  user-select: none;

  &:hover {
    font-weight: 600
  }
`;
